import { IconButton } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import { forwardRef } from "react";
import { useStyles } from "./styles";

type Helpers = {
  closeNotification: () => void;
};

interface Props extends CustomContentProps {
  button?: {
    text: string;
    onClick: (helpers: Helpers) => void;
  };
}

export const DefaultToast = forwardRef<HTMLDivElement, Props>(
  ({ id, message, button, style }, ref) => {
    const classes = useStyles();
    const { closeSnackbar } = useSnackbar();

    return (
      <SnackbarContent ref={ref} className={classes.snackbar}>
        <div
          className={classes.snackWrapper}
          data-test-id="notification-container"
          style={style}
        >
          <span className={classes.text} data-test-id="notification-message">
            {message}
          </span>
          {button && (
            <OLButton
              data-test-id="notification-button"
              variant="text"
              className={classes.snackbarButton}
              onClick={() => {
                button.onClick({ closeNotification: () => closeSnackbar(id) });
              }}
            >
              {button.text}
            </OLButton>
          )}
          <IconButton
            data-test-id="notification-close"
            className={classes.iconClose}
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(id)}
            size="small"
          >
            <XCloseIcon />
          </IconButton>
        </div>
      </SnackbarContent>
    );
  },
);
